import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "services/api";
import Spinner from "../../../elements/Spinner";
import swal from "sweetalert";
import Select from "react-select";

export default function CreateTechpack(props) {
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const handleImageChange = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageFile(file);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile(null);
      setImagePreview("");
    }
  };
  const [buyers, setBuyers] = useState([]);
  const getBuyers = async () => {
    setSpinner(true);
    var response = await api.post("/buyers");
    if (response.status === 200 && response.data) {
      setBuyers(response.data.data);
    } else {
      console.log(response.data);
    }
    setSpinner(false);
  };
  const [sizes, setSizes] = useState([]);
  const getSizes = async () => {
    setSpinner(true);
    var response = await api.post("/sizes");
    if (response.status === 200 && response.data) {
      setSizes(response.data.data);
    }
    setSpinner(false);
  };

  const operations = ["Printing", "Embroidery", "Dyeing"];
  const [selectedOperations, setSelectedOperations] = useState([]);
  const handleCheckboxChange = (operation) => {
    if (selectedOperations.includes(operation)) {
      setSelectedOperations(
        selectedOperations.filter((op) => op !== operation)
      );
    } else {
      setSelectedOperations([...selectedOperations, operation]);
    }
  };

  // CREATE TECHPACK ON MODAL
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleFileSelection = (event) => {
    const files = event.target.files;
    setSelectedFiles([...selectedFiles, ...files]);
  };
  const handleFileDelete = (index) => {
    const newSelectedFiles = [...selectedFiles];
    newSelectedFiles.splice(index, 1);
    setSelectedFiles(newSelectedFiles);
  };

  const [techForm, setTechForm] = useState({
    buyer_id: "",
    title: "",
    season: "",
    item_type: "",
    item_name: "",
    description: "",
    wash_details: "",
    sizes: [],
    fds_shrinkage_length: "",
    fds_shrinkage_width: "",
    fds_gsm: "",
    fds_width: "",
    fds_composition: "",
    techpack_file: null,
    specsheet: null,
    block_pattern: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    if (ev.target.type === "file") {
      setTechForm({
        ...techForm,
        [name]: ev.target.files[0], // Save the file instead of the input value
      });
    } else {
      setTechForm({
        ...techForm,
        [name]: value, // Handle regular form fields
      });
    }
  };

  console.log("FORMDATA", techForm);

  const handleSizeChange = (selectedOptions) => {
    const selectedSizeIds = selectedOptions.map((option) => option.value);
    setTechForm((prevData) => ({
      ...prevData,
      sizes: selectedSizeIds,
    }));
  };

  const validateForm = () => {
    let formErrors = {};

    if (!techForm.buyer_id) {
      formErrors.buyer_id = "Buyer is required";
    }
    if (!techForm.title) {
      formErrors.title = "Techpack/Style is required";
    }
    if (!techForm.season) {
      formErrors.season = "Season is required";
    }
    if (!techForm.item_type) {
      formErrors.item_type = "Item Type is required";
    }
    if (!techForm.item_name) {
      formErrors.item_name = "Item Name is required";
    }

    if (!techForm.sizes.length) {
      formErrors.sizes = "Please Select Sizes";
    }
    if (!techForm.wash_details) {
      formErrors.wash_details = "Please Select Wash Details";
    }

    if (!techForm.techpack_file) {
      formErrors.techpack_file = "Techpack file is required";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const submitTechpack = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      var data = new FormData();
      data.append("buyer_id", techForm.buyer_id);
      data.append("title", techForm.title);
      data.append("season", techForm.season);
      data.append("item_type", techForm.item_type);
      data.append("item_name", techForm.item_name);
      data.append("sizes", techForm.sizes);
      data.append("wash_details", techForm.wash_details);
      data.append("operations", selectedOperations);
      data.append("description", techForm.description);
      data.append("fds_shrinkage_length", techForm.fds_shrinkage_length);
      data.append("fds_shrinkage_width", techForm.fds_shrinkage_width);
      data.append("fds_gsm", techForm.fds_gsm);
      data.append("fds_width", techForm.fds_width);
      data.append("fds_composition", techForm.fds_composition);
      data.append("photo", imageFile);
      data.append("techpack_file", techForm.techpack_file);
      data.append("specsheet", techForm.specsheet);
      data.append("block_pattern", techForm.block_pattern);
      for (let i = 0; i < selectedFiles.length; i++) {
        data.append("attatchments[]", selectedFiles[i]);
      }
      setSpinner(true);
      var response = await api.post("/techpacks-create", data);
      if (response.status === 200 && response.data) {
        setTechForm({
          buyer_id: "",
          title: "",
          season: "",
          item_type: "",
          item_name: "",
          description: "",
          wash_details: "",
          sizes: [],
          fds_shrinkage_length: "",
          fds_shrinkage_width: "",
          fds_gsm: "",
          fds_width: "",
          fds_composition: "",
          techpack_file: null,
          specsheet: null,
          block_pattern: null,
        });
        setErrors({});
        setSelectedFiles([]);
        history.push("/merchandising/techpacks");
      } else {
        setErrors(response.data.errors);
      }
      setSpinner(false);
    }
  };

  useEffect(async () => {
    getBuyers();
    getSizes();
  }, []);

  useEffect(() => {
    const checkAccess = async () => {
      const allowedDepartments = ["Merchandising"];
      if (!allowedDepartments.includes(props.userData?.department_title)) {
        await swal({
          icon: "error",
          text: "You Cannot Access This Section.",
          closeOnClickOutside: false,
        });
        history.push("/dashboard");
      }
    };
    checkAccess();
  }, [props.userData?.department_title, history]);

  return (
    <div className="create_edit_page">
      {spinner && <Spinner />}
      <div className="create_page_heading">
        <div className="page_name">Add New Techpack </div>
        <div className="actions">
          <Link
            to="/merchandising/techpacks"
            className="btn btn-danger rounded-circle"
          >
            <i className="fal fa-times"></i>
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-7 col-lg-8">
          <div className="row">
            <div className="col-6 col-md-4 col-lg-3">
              <div className="form-group">
                <label>
                  Buyer <sup>*</sup>
                </label>
                <select
                  name="buyer_id"
                  value={techForm.buyer_id}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select Buyer</option>
                  {buyers.length > 0 ? (
                    buyers.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  ) : (
                    <option value="0">No Buyers found</option>
                  )}
                </select>
                {errors.buyer_id && (
                  <div className="errorMsg">{errors.buyer_id}</div>
                )}
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3">
              <div className="form-group">
                <label>
                  Style/Index<sup>*</sup>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="title"
                  onChange={handleChange}
                  value={techForm.title}
                />

                {errors.title && <div className="errorMsg">{errors.title}</div>}
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3">
              <div className="form-group">
                <label>
                  Season <sup>*</sup>
                </label>
                <select
                  name="season"
                  value={techForm.season}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select Season</option>
                  <option value="FALL">FALL</option>
                  <option value="SUMMER">SUMMER</option>
                  <option value="SPRING">SPRING</option>
                  <option value="WINTER">WINTER</option>
                  <option value="HOLIDAY">HOLIDAY</option>
                </select>
                {errors.season && (
                  <div className="errorMsg">{errors.season}</div>
                )}
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3">
              <div className="form-group">
                <label>
                  Item Type <sup>*</sup>
                </label>
                <select
                  name="item_type"
                  value={techForm.item_type}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select Type</option>
                  <option value="Top">Top</option>
                  <option value="Bottom">Bottom</option>
                  <option value="Outwear">Outwear</option>
                  <option value="Kids">Kids</option>
                </select>
                {errors.item_type && (
                  <div className="errorMsg">{errors.item_type}</div>
                )}
              </div>
            </div>
            <div className="col-6 col-md-5 col-lg-5">
              <div className="form-group">
                <label>
                  Item Name<sup>*</sup>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="item_name"
                  onChange={handleChange}
                  value={techForm.item_name}
                />

                {errors.item_name && (
                  <div className="errorMsg">{errors.item_name}</div>
                )}
              </div>
            </div>

            <div className="col-12 col-md-7 col-lg-7">
              <div className="form-group" style={{ position: "relative" }}>
                <label>
                  Sizes <sup>*</sup>
                </label>
                <div style={{ position: "relative" }}>
                  <Select
                    isMulti
                    name="sizes"
                    placeholder="Select or Search"
                    value={techForm.sizes.map((sizeId) => {
                      const selectedSize = sizes.find(
                        (size) => size.id === sizeId
                      );
                      return {
                        value: sizeId,
                        label: selectedSize ? selectedSize.title : "",
                      };
                    })}
                    onChange={handleSizeChange}
                    options={sizes.map((size) => ({
                      value: size.id,
                      label: size.title,
                    }))}
                  />
                </div>
                {errors.sizes && <div className="errorMsg">{errors.sizes}</div>}
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3">
              <div className="form-group">
                <label>
                  Wash Details<sup>*</sup>
                </label>

                <select
                  name="wash_details"
                  value={techForm.wash_details}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select</option>
                  <option value="No Wash">No Wash</option>
                  <option value="Full Wash">Full Wash</option>
                  <option value="Wash Only Body">Wash Only Body</option>
                </select>
                {errors.wash_details && (
                  <div className="errorMsg">{errors.wash_details}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-md-8 col-lg-9">
              <div className="form-group">
                <label>Special Operations</label>
                <br />
                {operations.map((operation) => (
                  <span
                    key={operation}
                    className={`d-flex gap_10 border ${
                      selectedOperations.includes(operation) ? "selected" : ""
                    }`}
                    style={{
                      padding: "0 5px",
                      background: "#ddd",
                      margin: "5px",
                      float: "left",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedOperations.includes(operation)}
                      onChange={() => handleCheckboxChange(operation)}
                    />
                    <span>{operation}</span>
                  </span>
                ))}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>

            <div className="col-12">
              <div
                className="fds_area"
                style={{
                  border: "2px dashed #e6e6e6",
                  padding: "15px",
                }}
              >
                <h5>
                  FDS (Fabric Details with Shrinkage, GSM, Width, Composition)
                </h5>
                <hr />
                <div className="row">
                  <div
                    className="col-3"
                    style={{
                      borderRight: "2px solid #e6e6e6",
                    }}
                  >
                    <div className="form-group">
                      <label>Shrinkage</label>
                      <div className="d-flex gap_10">
                        <input
                          className="form-control"
                          name="fds_shrinkage_length"
                          value={techForm.fds_shrinkage_length}
                          onChange={handleChange}
                          placeholder="Length"
                        />
                        <input
                          className="form-control"
                          name="fds_shrinkage_width"
                          value={techForm.fds_shrinkage_width}
                          onChange={handleChange}
                          placeholder="Width"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>GSM</label>
                      <input
                        className="form-control"
                        name="fds_gsm"
                        value={techForm.fds_gsm}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Width</label>
                      <input
                        className="form-control"
                        name="fds_width"
                        value={techForm.fds_width}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Composition</label>
                      <input
                        className="form-control"
                        name="fds_composition"
                        value={techForm.fds_composition}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-md-5 col-lg-4"
          style={{
            borderLeft: "2px solid #ef9a3e",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label for="fileInput">
                  <input
                    id="fileInput"
                    onChange={handleImageChange}
                    hidden
                    type="file"
                    accept="image/*"
                  />
                  <div
                    for="fileInput"
                    className="file_preview"
                    style={{
                      border: "2px dashed #e6e6e6",
                      borderRadius: "8px",
                      width: "200px",
                      height: "150px",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    ) : (
                      <i
                        className="fa fa-camera fa-2x"
                        style={{
                          paddingTop: "55px",
                          textAlign: "center",
                        }}
                      ></i>
                    )}
                  </div>
                </label>
              </div>
            </div>

            <div className="col-12">
              <br />
              <div
                className="fds_area"
                style={{
                  border: "2px dashed #e6e6e6",
                  padding: "15px",
                }}
              >
                <h5>
                  <strong>Attachments</strong>{" "}
                  <small className="text-muted">
                    (PDF,Word,Excel,JPEG,PNG file.)
                  </small>
                </h5>
                <label
                  for="techpack"
                  className="techpack_file d-flex gap_10 align-items-center border rounded mb-10"
                >
                  <div
                    style={{
                      paddingLeft: "15px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      width: "35%",
                    }}
                  >
                    Techpack:{" "}
                  </div>
                  <input
                    id="techpack"
                    className="form-control margin_bottom_0"
                    type="file"
                    name="techpack_file"
                    onChange={handleChange}
                  />
                </label>
                {errors.techpack_file && (
                  <div className="errorMsg">{errors.techpack_file}</div>
                )}
                <label
                  for="specsheet"
                  className="techpack_file d-flex gap_10 align-items-center border rounded mb-10"
                >
                  <div
                    style={{
                      paddingLeft: "15px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      width: "35%",
                    }}
                  >
                    Spec Sheet:{" "}
                  </div>
                  <input
                    id="specsheet"
                    className="form-control margin_bottom_0"
                    type="file"
                    name="specsheet"
                    onChange={handleChange}
                  />
                </label>
                <label
                  for="blockpattern"
                  className="techpack_file d-flex gap_10 align-items-center border rounded mb-10"
                >
                  <div
                    style={{
                      paddingLeft: "15px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      width: "35%",
                    }}
                  >
                    Block Pattern:{" "}
                  </div>
                  <input
                    id="blockpattern"
                    className="form-control margin_bottom_0"
                    type="file"
                    name="block_pattern"
                    onChange={handleChange}
                  />
                </label>

                <h5>
                  <strong>Others:</strong>
                </h5>
                <div className="d-flex mb-10">
                  <input
                    type="file"
                    className="form-control margin_bottom_0"
                    multiple
                    accept=".pdf, .xlsx, .xls, .csv"
                    onChange={handleFileSelection}
                    id="input_files"
                  />
                  <div className="d-flex margin_left_30">
                    <label
                      for="input_files"
                      className="btn btn-info rounded-circle btn-xs"
                    >
                      <i className="fal fa-plus"></i>
                    </label>
                  </div>
                </div>

                {selectedFiles.map((file, index) => (
                  <div key={file.name} className="d-flex mb-10">
                    <input
                      className="form-control margin_bottom_0"
                      disabled
                      value={file.name}
                    />
                    <div className="d-flex">
                      <button
                        onClick={() => handleFileDelete(index)}
                        className="btn btn-danger rounded-circle margin_left_15 btn-xs"
                      >
                        <i className="fal fa-times"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <hr />
      <div className="submit_area d-flex gap_10 justify-content-center">
        <button onClick={submitTechpack} className="btn btn-success btn-md">
          SAVE
        </button>
        <Link to="/merchandising/techpacks" className="btn btn-danger btn-md">
          GO BACK
        </Link>
      </div>
    </div>
  );
}
